import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    connect() {
        this.abortController = new AbortController()
        this.boundRefresh = this.refresh.bind(this)
        this.boundBeforeCache = this.destroySelect2.bind(this)

        this.initializeSelect2()

        window.addEventListener("pageshow", this.boundRefresh, { signal: this.abortController.signal })
        document.addEventListener("turbo:before-cache", this.boundBeforeCache, { signal: this.abortController.signal })

        const tabPane = this.element.closest(".tab-pane")
        if (tabPane) {
            const trigger = document.querySelector(`[data-bs-target="#${tabPane.id}"]`)
            trigger?.addEventListener("shown.bs.tab", this.boundRefresh, { signal: this.abortController.signal })
        }
    }

    disconnect() {
        this.abortController?.abort()
        this.destroySelect2()
    }

    refresh() {
        this.initializeSelect2()
    }

    initializeSelect2() {
        this.destroySelect2()
        $(this.element).select2({
            theme: "erp",
            width: "100%",
            dropdownParent: $(this.element.closest(".dialog") || document.body)
        })
    }

    destroySelect2() {
        if ($(this.element).hasClass("select2-hidden-accessible")) {
            $(this.element).select2("destroy")
        }
    }

}
